<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,
body,
#app {
  width: 100%;
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
}
.backdrop {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.common {
  padding: 15px;
  background-color: #ffffff;
  margin-bottom: 10px;
}
.cell-row {
  display: flex;
  font-size: 15px;
  padding: 8px 0;
}
.cell-row .row {
  color: #000000;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
}
.cell-row .row:first-child {
  flex: 1;
  min-width: 80px;
}
.cell-row .row input {
  width: 100%;
  border: none;
  line-height: 20px;
  outline: none;
  text-align: right;
  font-size: 15px;
  padding: 0;
}
.cell-row .row span {
  color: #909090;
}
/* 上传图片 */
.uploadImg .uploadImgFile {
  width: 60px;
  height: 60px;
  cursor: pointer;
  position: relative;
  background: url(./assets/images/evaluate-add.png) no-repeat #f6f6f6;
  background-position: center;
  -webkit-background-size: cover;
  background-size: 45% 45%;
  display: inline-block;
  margin: 12px 5px 0 0;
}
.uploadImg .uploadImgFile .uploadImg {
  position: absolute;
  right: 0;
  top:0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.uploadImg .uploadImgList {
  width: 60px;
  height: 60px;
  position: relative;
  display: inline-block;
  margin: 12px 8px 0 0;
}
.uploadImg .uploadImgList img {
  width: 100%;
  height: 100%;
}
.uploadImg .uploadImgList .del {
  width: 20px;
  height: 20px;
  position: absolute;
  top: -5px;
  right: -5px;
}
.previewimg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 99;
  align-items: center;
  justify-content: center;
  display: flex;
}
.previewimg img {
  max-width: 80%;
  max-height: 80%;
  position: absolute;
}
.previewimg div {
  width: 100%;
  height: 100%;
}
/* 加载中 */
.loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0);
  z-index: 99;
  align-items: center;
  justify-content: center;
  display: flex;
}
.loading img {
  width: 32px;
  height: 32px;
}
/* 公共头部带返回样式 */
.title-box {
  padding: 10px 6px;
  display: flex;
  font-size: 15px;
}
.title-box span {
  flex: 1;
  text-align: center;
}
.title-box img:first-child {
  width: 18px;
  height: 18px;
  padding-top: 4px;
}
.title-box img:last-child {
  width: 25px;
  height: 25px;
}
/* 公共搜索框样式 */
.search-box {
  display: flex;
  position: relative;
  margin-bottom: 0;
}
.search-box input {
  flex: 1;
  width: 100%;
  height: 27px;
  background-color: #f8f8f8;
  border-radius: 14px;
  border: none;
  padding: 0 28px 0 30px;
  background-image: url(./assets/images/repairman-search.png);
  background-size: 14px 14px;
  background-repeat: no-repeat;
  background-position: 9px center;
  outline: none;
  font-size: 14px;
}
.search-box div {
  line-height: 27px;
  padding-left: 10px;
}
/* 公共商品列表样式 */
.common-goods .common-goods-list {
  display: flex;
  background-color: #ffffff;
  padding: 12px;
}
.common-goods .common-goods-list .goods-img {
  width: 75px;
  height: 75px;
}
.common-goods .common-goods-list .goods-detail {
  flex: 1;
  padding: 0 12px;
}
.common-goods .common-goods-list .goods-detail .item {
  color: #989898;
  font-size: 13px;
}
.common-goods .common-goods-list .goods-detail .name {
  font-size: 15px;
  color: #43464f;
  font-weight: 700;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
}
.common-goods .common-goods-total {
  padding: 10px 15px;
  font-size: 14px;
  color: #8f8f8f;
}
/* mint-ui的日期选择框 */
.picker-items {
  width: 100%;
}
strong {
  color: red;
  padding-left: 2px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue